import restClient from "./RestClient";
import {PtRouteType, RoadInfrastructureRouteEntity} from "./entities/replancity_RoadInfrastructureRoute";
import type * as schema from './schema';
import {EntityServiceName} from "./enums/enums";

export const serviceApi = {
  groupUpdate(
      data: schema.paths["/services/replancity_RoadInfrastructureService/groupSaveAndUpdateV2"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<any[]> {
    return restClient.fetch({
      method: "POST",
      path: `services/replancity_RoadInfrastructureService/groupSaveAndUpdateV2`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

    ptRoutesGroupUpdate(
      data: schema.paths["/services/replancity_PublicTransitService/groupSaveAndUpdate"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<any[]> {
    return restClient.fetch({
      method: "POST",
      path: `services/replancity_PublicTransitService/groupSaveAndUpdate`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  groupManipulate: function (
      data: {
        task: {
          presetId: string;
          type: 'DELETE';
          targets: string[];
        }
      },
      abortSignal: AbortSignal
  ):
      Promise<any> {
    return restClient.fetch({
      method: "POST",
      path: `services/replancity_RoadInfrastructureService/groupManipulate`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  getModes: <T extends Record<string, unknown>> (
    serviceName: EntityServiceName,
    data: T,
    abortSignal: AbortSignal
  ):
    Promise<string[]> => {
    return restClient.fetch({
      method: "GET",
      path: `services/${serviceName}/listAllModes`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  calculateAndGetRouteGeometry: function (
      serviceName: EntityServiceName,
      data: schema.paths["/services/replancity_RoadInfrastructureService/calculateRoute"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<RoadInfrastructureRouteEntity> {
    return restClient.fetch({
      method: "GET",
      path: `services/${serviceName}/calculateRoute`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  calculateAndGetPtRouteGeometry: function (
      serviceName: EntityServiceName,
      data: schema.parameters['replancity_PublicTransitService_calculateRoute_paramsObject_POST'],
      abortSignal: AbortSignal
  ):
      Promise<PtRouteType> {
    return restClient.fetch({
      method: "GET",
      path: `services/${serviceName}/calculateRoute`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

  listAllHighways: function (
      data: schema.paths["/services/replancity_RoadInfrastructureService/listAllHighways"]["get"]["parameters"]["query"],
      abortSignal: AbortSignal
  ):
      Promise<{id: string; name: string;}[]> {
    return restClient.fetch({
      method: "GET",
      path: `services/replancity_RoadInfrastructureService/listAllHighways`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

    listAllVehicleTypeNames: (
    data: schema.paths["/services/replancity_PublicTransitService/listAllVehicleTypeNames"]["get"]["parameters"]["query"],
    abortSignal: AbortSignal
  ):
      Promise<string[]> => {
    return restClient.fetch({
      method: "GET",
      path: `services/replancity_PublicTransitService/listAllVehicleTypeNames`,
      data,
      fetchOptions: {signal: abortSignal}
    });
  },

}